<template>
  <div :class="divTableClassName">
    <div :class="tableWrapperClassName">
      <table :class="tableBodyClassName">
        <tbody>
          <slot />
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KeyValueTable',

  provide() {
    return {
      KeyValueTable: this
    }
  },

  data() {
    return {
      loading: true
    }
  },

  props: {
    rightWidth: {
      required: false
    },
    leftWidth: {
      required: false
    }
  },

  computed: {
    divTableClassName() {
      return 'page el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition'
    },

    tableWrapperClassName() {
      return 'el-table__body-wrapper is-scrolling-none'
    },

    tableBodyClassName() {
      return 'el-table__body'
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100%;
}

table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/components/table/KeyValueTable.vue